module.exports = __webpack_public_path__ + "static/media/logo-bottom.5adf0965.svg";